<template>
    <section>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1 class="mb-5">{{ resultCount }} Zoekresultaten</h1>
                    <h3 class="mb-5">
                        Je hebt gezocht op de volgende zoekterm: {{ query }}
                    </h3>
                    <ul class="search__results">
                        <li
                            v-for="(result, index) in results"
                            :key="index"
                            class="mb-4"
                        >
                            <a
                                :href="result.url"
                                class="color--black position-relative d-block"
                            >
                                <h3>{{ result.title }}</h3>
                                <p>
                                    {{ result.excerpt }}
                                </p>
                                <i
                                    class="fa fa-arrow-right"
                                    aria-hidden="true"
                                ></i>
                            </a>
                        </li>
                    </ul>
                    <v-pagination
                        v-model="page"
                        :length="totalPages"
                    ></v-pagination>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Axios from 'axios';

export default {
    data() {
        return {
            results: [],
            resultCount: 0,
            totalPages: 0,
            pages: [],
            url: '/api/search/searchactivities?searchTerm=',
            hideSearch: true,
            query: '',
            currentQuery: '',
            page: 1
        };
    },
    computed: {
        totalResults() {
            return this.resultCount;
        }
    },
    watch: {
        page: function(oldValue, newValue) {
            if (oldValue !== newValue) {
                this.getSearchResults();
            }
        }
    },
    mounted() {
        if (this.$route.query.searchTerm) {
            this.query = this.$route.query.searchTerm;
        }
        if (this.$route.query.page) {
            this.page = this.$route.query.page;
        }

        this.getSearchResults();
    },
    methods: {
        getSearchResults() {
            Axios.get(this.url + this.query + '&page=' + (this.page - 1))
                .then(response => {
                    this.totalPages = response.data.totalPages;
                    this.results = response.data.searchResults;
                    this.resultCount = response.data.totalResults;
                    this.currentQuery = this.query;
                    this.pages = [];
                    for (let i = 0; i < response.data.content.pages; i++) {
                        this.pages.push(i + 1);
                    }

                    return true;
                })
                .catch(() => false);
        },
        setCurrentPage(page) {
            this.page = page;
            this.$router.push({
                query: { searchTerm: this.query, page: page }
            });
            this.getSearchResults();
            const results = document.querySelector('#search-results');
            if (this.query !== '') {
                results.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.search__results li {
    border-bottom: 1px solid $black;
}

.search__results i {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
}
</style>
